var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ix-router-link',{staticClass:"tag",attrs:{"to":_vm.gallery.url},nativeOn:{"click":function($event){$event.stopImmediatePropagation();_vm.handleNav()}}},[_vm._v(_vm._s(_vm.gallery.name))])}
var staticRenderFns = []

export { render, staticRenderFns }